const ConfirmDialog = ({
  isOpen,
  title = 'Confirm Action',
  message = 'Are you sure you want to continue?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'danger',
  secondaryText,
  secondaryVariant = 'warning',
  isLoading = false,
  onConfirm,
  onSecondary,
  onCancel
}) => {
  if (!isOpen) return null;

  const resolveVariantClass = (variant) =>
    variant === 'danger'
      ? 'bg-red-600 hover:bg-red-700'
      : variant === 'warning'
      ? 'bg-amber-600 hover:bg-amber-700'
      : 'bg-emerald-600 hover:bg-emerald-700';

  const confirmClass = resolveVariantClass(confirmVariant);
  const secondaryClass = resolveVariantClass(secondaryVariant);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-md rounded-xl bg-white shadow-xl">
        <div className="border-b border-gray-200 px-4 py-4 sm:px-6">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
        <div className="px-4 py-4 sm:px-6">
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <div className="flex flex-col-reverse gap-2 border-t border-gray-200 px-4 py-4 sm:flex-row sm:justify-end sm:gap-3 sm:px-6">
          <button
            type="button"
            className="order-1 w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 sm:order-none sm:w-auto sm:px-4 sm:py-2"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          {secondaryText && onSecondary ? (
            <button
              type="button"
              className={`order-2 w-full rounded-lg px-4 py-2.5 text-sm font-medium text-white transition sm:order-none sm:w-auto sm:px-4 sm:py-2 ${secondaryClass} disabled:cursor-not-allowed disabled:opacity-60`}
              onClick={onSecondary}
              disabled={isLoading}
            >
              {isLoading ? 'Please wait...' : secondaryText}
            </button>
          ) : null}
          <button
            type="button"
            className={`order-3 w-full rounded-lg px-4 py-2.5 text-sm font-medium text-white transition sm:order-none sm:w-auto sm:px-4 sm:py-2 ${confirmClass} disabled:cursor-not-allowed disabled:opacity-60`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Please wait...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
